import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";

import { crudeDatabase } from "../data/crudeDatabase";
import { generateBlend } from "../engine/blendEngine";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";


function BlendLaboratory({ onClose }) {

    const page1Ref = useRef(null);

    const page2Ref = useRef(null);

    const page3Ref = useRef(null);

    const page4Ref = useRef(null);

    const page5Ref = useRef(null);


    const reportNumber =
        `LAB-${new Date().getFullYear()

        }${String(new Date().getMonth() + 1).padStart(2, "0")

        }${String(new Date().getDate()).padStart(2, "0")

        }-${Math.floor(Math.random() * 900000 + 100000)

        }`;



    const reportDate =
        new Date().toLocaleDateString();

    const reportTime =
        new Date().toLocaleTimeString();


    const blendTanks = [];

    const LT1401 =
        Number(localStorage.getItem("LT_1401")) || 0;

    const LT1402 =
        Number(localStorage.getItem("LT_1402")) || 0;

    if (LT1401 > 0)
        blendTanks.push("V-1401");

    if (LT1402 > 0)
        blendTanks.push("V-1402");


    const totalQuantity =
        LT1401 + LT1402;


    const blendStatus =
        totalQuantity > 0
            ?
            "AVAILABLE"
            :
            "EMPTY";




    const getProperty = (
        section,
        index
    ) => {

        return (

            blend
                ?.properties
                ?.[
                section
            ]
                ?.[
                index
            ]
                ?.value

            ??

            "-"

        );

    };

    


    

    const blend = generateBlend();

const crude1 = blend.feedCrudes?.crude1 || {};
const crude2 = blend.feedCrudes?.crude2 || {};


console.log("Crude 1", crude1);
console.log("Crude 2", crude2);





    const blended = blend.properties;



    const formatProperty = (prop) => {

        if (prop == null) return "-";

        // Number or string
        if (typeof prop !== "object")
            return prop;

        // value
        if ("value" in prop)
            return `${prop.value}${prop.unit ? " " + prop.unit : ""}`;

        // valueMin/valueMax
        if ("valueMin" in prop && "valueMax" in prop)
            return `${prop.valueMin} - ${prop.valueMax}${prop.unit ? " " + prop.unit : ""}`;

        // valueMin only
        if ("valueMin" in prop)
            return `${prop.valueMin}${prop.unit ? " " + prop.unit : ""}`;

        // valueMax only
        if ("valueMax" in prop)
            return `${prop.valueMax}${prop.unit ? " " + prop.unit : ""}`;

        return "-";

    };




    const formatYield = (value) => {

        if (value == null) return "-";

        // simple number
        if (
            typeof value === "number" ||
            typeof value === "string"
        ) {
            return value;
        }

        // { value: xx }
        if (typeof value === "object") {

            if (value.value !== undefined)
                return value.value;

            if (value.valueMin !== undefined &&
                value.valueMax !== undefined)
                return `${value.valueMin} - ${value.valueMax}`;

            if (value.valueMin !== undefined)
                return value.valueMin;

            if (value.valueMax !== undefined)
                return value.valueMax;
        }

        return "-";
    };





    const apiGravity =
        getProperty(
            "physicalProperties",
            7
        );


    const density =
        getProperty(
            "physicalProperties",
            9
        );


    const sulfur =
        getProperty(
            "bulkElementalComposition",
            3
        );


    const viscosity20 =
        getProperty(
            "physicalProperties",
            10
        );


    const tan =
        getProperty(
            "corrosionStability",
            24
        );


    const water =
        getProperty(
            "physicalProperties",
            20
        );


    const salt =
        getProperty(
            "physicalProperties",
            19
        );




    /* ==========================================
       TBP DISTILLATION
    ========================================== */


    const tbp =
        blend?.properties?.tbpDistillation || {};



    const cutYields =
        blend?.properties?.cutYields || {};



    console.log("Blend Laboratory:", blend);



    const { processData } =
        useContext(ProcessContext);


    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);





    const PropertyRow = ({ label, value }) => (

        <tr>

            <td>
                {label}
            </td>

            <td>

                {
                    value?.value !== undefined
                        ?
                        `${value.value} ${value.unit || ""}`
                        :
                        "-"
                }

            </td>

        </tr>

    );



    const handlePrint = () => {
        window.print();
    };


    const handlePDF = async () => {

    const pdf = new jsPDF(
        "p",
        "mm",
        "a4"
    );

    const pageWidth = 210;
    const pageHeight = 297;

    const pages = [

        page1Ref,
        page2Ref,
        page3Ref,
        page4Ref,
        page5Ref

    ];

    for (let i = 0; i < pages.length; i++) {

        const page = pages[i].current;

        if (!page) continue;

        const canvas = await html2canvas(page, {

            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff"

        });

        const imgData = canvas.toDataURL(
            "image/jpeg",
            0.92
        );

        const imgWidth = pageWidth;

        const imgHeight =
            canvas.height *
            imgWidth /
            canvas.width;

        if (i > 0) {

            pdf.addPage();

        }

        pdf.addImage(

            imgData,

            "JPEG",

            0,

            0,

            imgWidth,

            Math.min(imgHeight, pageHeight)

        );

    }

    pdf.save(`${reportNumber}.pdf`);

};









    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">


                <div
                    ref={page1Ref}
                    className="receipt-page"
                >


                    <div className="receipt-company">

                        <div className="receipt-logo">

                            NK

                        </div>

                        <div className="receipt-company-details">

                            <h1>

                                NK TECH NIGERIA LIMITED

                            </h1>

                            <h2>

                                Industrial DCS & Digital Twin Solution

                            </h2>

                            <h3>

                                CRUDE BLENDING LABORATORY REPORT

                            </h3>

                            <p>

                                Refinery Digital Twin • Blend Optimization • Laboratory Information Management

                            </p>

                            <p>

                                Yenagoa, Bayelsa State, Nigeria

                            </p>

                        </div>

                    </div>

                    <hr />


                    <div className="summary-grid">

                        <div className="summary-card">

                            <div className="summary-title">

                                STATUS

                            </div>

                            <div className="summary-value">

                                {blendStatus}

                            </div>

                        </div>

                        <div className="summary-card">

                            <div className="summary-title">

                                BLEND TANKS

                            </div>

                            <div className="summary-value">

                                {blendTanks.join(", ") || "-"}

                            </div>

                        </div>

                        <div className="summary-card">

                            <div className="summary-title">

                                TOTAL FLOW

                            </div>

                            <div className="summary-value">

                                {blend.flowInfo.totalFlow.toFixed(2)}

                            </div>

                        </div>

                        <div className="summary-card">

                            <div className="summary-title">

                                QUANTITY

                            </div>

                            <div className="summary-value">

                                {totalQuantity.toFixed(1)}

                            </div>

                        </div>

                    </div>

                    <hr />


                    <h3 className="section-title">

                        LABORATORY INFORMATION

                    </h3>

                    <table className="receipt-table">

                        <tbody>

                            <tr>

                                <td>

                                    Blend ID

                                </td>

                                <td>

                                    {blend.blendInfo.blendID}

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Report Number

                                </td>

                                <td>

                                    {reportNumber}

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Blend Name

                                </td>

                                <td>

                                    {blend.blendInfo.blendName}

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Date

                                </td>

                                <td>

                                    {reportDate}

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Time

                                </td>

                                <td>

                                    {reportTime}

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Status

                                </td>

                                <td>

                                    {blendStatus}

                                </td>

                            </tr>

                        </tbody>

                    </table>


                    <h3 className="section-title">

                        BLEND CONTRIBUTORS

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>

                                    Tank

                                </th>

                                <th>

                                    Crude

                                </th>

                                <th>

                                    Flow

                                </th>

                                <th>

                                    Contribution

                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {

                                blend.contributors.map((item, index) => (

                                    <tr key={index}>

                                        <td>

                                            {item.tank}

                                        </td>

                                        <td>

                                            {item.crudeName}

                                        </td>

                                        <td>

                                            {item.flow.toFixed(2)}

                                        </td>

                                        <td>

                                            {item.contribution.toFixed(2)}%

                                        </td>

                                    </tr>

                                ))

                            }

                        </tbody>

                    </table>


                    <h3 className="section-title">

                        BLEND RATIO

                    </h3>

                    <table className="receipt-table">

                        <tbody>

                            <tr>

                                <td>

                                    Crude 1

                                </td>

                                <td>

                                    {blend.flowInfo.ratio1Percent.toFixed(1)}%

                                </td>

                            </tr>

                            <tr>

                                <td>

                                    Crude 2

                                </td>

                                <td>

                                    {blend.flowInfo.ratio2Percent.toFixed(1)}%

                                </td>

                            </tr>

                        </tbody>

                    </table>



                    <div className="barcode-area">

                        <Barcode

                            value={reportNumber}

                            displayValue={false}

                            height={45}

                        />

                        <div>

                            {reportNumber}

                        </div>

                    </div>

                    <div className="receipt-security">

                        <QRCode
                            value={blend.blendInfo?.blendID || "NK-BLEND"}
                            size={95}
                        />

                    </div>



                    <div className="receipt-signatures">

                        <div className="signature-box">

                            ____________________

                            <br /><br />

                            Laboratory Analyst

                        </div>

                        <div className="signature-box">

                            ____________________

                            <br /><br />

                            Shift Supervisor

                        </div>

                        <div className="signature-box">

                            ____________________

                            <br /><br />

                            Control Room Operator

                        </div>

                    </div>

                    <div className="receipt-page-footer">

                        BLEND LABORATORY REPORT

                        <br />

                        Generated electronically by

                        <strong>

                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                        </strong>

                        <br />

                        Page 1 of 5

                    </div>







                <div
                    ref={page2Ref}
                    className="receipt-page"
                >




                    <div className="customer-stamp">
                        FEED & BLEND QUALITY
                    </div>

                    <div className="receipt-company">

                        <div className="receipt-logo">
                            NK
                        </div>

                        <div className="receipt-company-details">

                            <h2>
                                CRUDE ASSAY COMPARISON
                            </h2>

                            <p>
                                Feed Crude vs Final Blend
                            </p>

                        </div>

                    </div>

                    <hr />

                    <h3 className="section-title">
                        QUALITY COMPARISON
                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Property</th>

                                <th>
                                    {blend.feedCrudes?.crude1?.name || "Crude 1"}
                                </th>

                                <th>
                                    {blend.feedCrudes?.crude2?.name || "Crude 2"}
                                </th>

                                <th>
                                    Final Blend
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>

                                <td>
                                    API Gravity
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[0]?.crude?.physicalProperties?.[7]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[2]?.crude?.physicalProperties?.[7]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blended.physicalProperties?.[7]
                                        )
                                    }
                                </td>

                            </tr>

                            <tr>

                                <td>
                                    Density
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[0]?.crude?.physicalProperties?.[9]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[2]?.crude?.physicalProperties?.[9]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blended.physicalProperties?.[9]
                                        )
                                    }
                                </td>

                            </tr>

                            <tr>

                                <td>
                                    Sulfur
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[0]?.crude?.bulkElementalComposition?.[3]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[2]?.crude?.bulkElementalComposition?.[3]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blended.bulkElementalComposition?.[3]
                                        )
                                    }
                                </td>

                            </tr>

                            <tr>

                                <td>
                                    TAN
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[0]?.crude?.corrosionStability?.[24]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[2]?.crude?.corrosionStability?.[24]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blended.corrosionStability?.[24]
                                        )
                                    }
                                </td>

                            </tr>

                            <tr>

                                <td>
                                    Carbon
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[0]?.crude?.bulkElementalComposition?.[1]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blend.streams?.[2]?.crude?.bulkElementalComposition?.[1]
                                        )
                                    }
                                </td>

                                <td>
                                    {
                                        formatProperty(
                                            blended.bulkElementalComposition?.[1]
                                        )
                                    }
                                </td>

                            </tr>

                        </tbody>

                    </table>

                    <h3 className="section-title">
                        LABORATORY OBSERVATION
                    </h3>

                    <div className="remarks-box">

                        Feed crude properties have been compared with the predicted blended crude properties generated from the NK Tech Industrial DCS Blend Engine.

                        <br /><br />

                        All blended values are calculated automatically using real-time flow-weighted averaging.

                    </div>

                    <div className="receipt-page-footer">

                        Generated electronically by

                        <strong>
                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                        </strong>

                        <br />

                        Page 2 of 5

                    </div>

                </div>



                {/*=====================================================
PAGE 3
=====================================================*/}

                <div
                    ref={page3Ref}
                    className="receipt-page"
                >

                    <div className="customer-stamp">

                        DETAILED PHYSICAL ANALYSIS

                    </div>

                    <div className="receipt-company">

                        <div className="receipt-logo">

                            NK

                        </div>

                        <div className="receipt-company-details">

                            <h2>

                                PHYSICAL PROPERTY COMPARISON

                            </h2>

                            <p>

                                Feed Crudes vs Predicted Blend

                            </p>

                        </div>

                    </div>

                    <hr />



                    <h3 className="section-title">

                        PHYSICAL PROPERTIES

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Property</th>
                                <th>Crude 1</th>
                                <th>Crude 2</th>
                                <th>Final Blend</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>Specific Gravity</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[8])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[8])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[8])}</td>
                            </tr>

                            <tr>
                                <td>Density @15°C</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[9])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[9])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[9])}</td>
                            </tr>

                            <tr>
                                <td>Viscosity @20°C</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[10])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[10])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[10])}</td>
                            </tr>

                            <tr>
                                <td>Viscosity @40°C</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[11])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[11])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[11])}</td>
                            </tr>

                            <tr>
                                <td>Viscosity @50°C</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[12])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[12])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[12])}</td>
                            </tr>

                            <tr>
                                <td>Viscosity @100°C</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[13])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[13])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[13])}</td>
                            </tr>

                            <tr>
                                <td>Pour Point</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[14])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[14])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[14])}</td>
                            </tr>

                            <tr>
                                <td>Cloud Point</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[15])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[15])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[15])}</td>
                            </tr>

                            <tr>
                                <td>Flash Point</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[16])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[16])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[16])}</td>
                            </tr>

                            <tr>
                                <td>Fire Point</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[17])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[17])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[17])}</td>
                            </tr>

                            <tr>
                                <td>RVP</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[18])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[18])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[18])}</td>
                            </tr>

                            <tr>
                                <td>Salt Content</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[19])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[19])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[19])}</td>
                            </tr>

                            <tr>
                                <td>Water Content</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[20])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[20])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[20])}</td>
                            </tr>

                            <tr>
                                <td>Sediment</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[21])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[21])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[21])}</td>
                            </tr>

                            <tr>
                                <td>BS&W</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[22])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[22])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[22])}</td>
                            </tr>

                            <tr>
                                <td>Ash Content</td>
                                <td>{formatProperty(crude1?.physicalProperties?.[23])}</td>
                                <td>{formatProperty(crude2?.physicalProperties?.[23])}</td>
                                <td>{formatProperty(blended.physicalProperties?.[23])}</td>
                            </tr>

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        LABORATORY REMARK

                    </h3>

                    <div className="remarks-box">

                        Physical properties shown above were generated automatically
                        from the NK Tech Blend Engine using real-time flow weighted
                        averaging of the incoming crude streams.

                        <br /><br />

                        The predicted blended crude satisfies refinery feedstock
                        quality monitoring requirements for process simulation,
                        operational planning and digital twin applications.

                    </div>



                    <div className="receipt-page-footer">

                        Generated electronically by

                        <strong>

                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                        </strong>

                        <br />

                        Page 3 of 5

                    </div>

                </div>


                {/*=====================================================
PAGE 4
=====================================================*/}

                <div
                    ref={page4Ref}
                    className="receipt-page"
                >

                    <div className="customer-stamp">

                        CORROSION • METALS • SARA

                    </div>

                    <div className="receipt-company">

                        <div className="receipt-logo">

                            NK

                        </div>

                        <div className="receipt-company-details">

                            <h2>

                                ADVANCED LABORATORY ANALYSIS

                            </h2>

                            <p>

                                Corrosion, Trace Metals & SARA Evaluation

                            </p>

                        </div>

                    </div>

                    <hr />



                    <h3 className="section-title">

                        CORROSION & STABILITY

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Property</th>
                                <th>Crude 1</th>
                                <th>Crude 2</th>
                                <th>Final Blend</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>Total Acid Number (TAN)</td>
                                <td>{formatProperty(crude1?.corrosionStability?.[24])}</td>
                                <td>{formatProperty(crude2?.corrosionStability?.[24])}</td>
                                <td>{formatProperty(blended.corrosionStability?.[24])}</td>
                            </tr>

                            <tr>
                                <td>Strong Acid Number (SAN)</td>
                                <td>{formatProperty(crude1?.corrosionStability?.[25])}</td>
                                <td>{formatProperty(crude2?.corrosionStability?.[25])}</td>
                                <td>{formatProperty(blended.corrosionStability?.[25])}</td>
                            </tr>

                            <tr>
                                <td>Mercaptan Sulfur</td>
                                <td>{formatProperty(crude1?.corrosionStability?.[26])}</td>
                                <td>{formatProperty(crude2?.corrosionStability?.[26])}</td>
                                <td>{formatProperty(blended.corrosionStability?.[26])}</td>
                            </tr>

                            <tr>
                                <td>H₂S in Liquid</td>
                                <td>{formatProperty(crude1?.corrosionStability?.[27])}</td>
                                <td>{formatProperty(crude2?.corrosionStability?.[27])}</td>
                                <td>{formatProperty(blended.corrosionStability?.[27])}</td>
                            </tr>

                            <tr>
                                <td>Organic Chlorides</td>
                                <td>{formatProperty(crude1?.corrosionStability?.[29])}</td>
                                <td>{formatProperty(crude2?.corrosionStability?.[29])}</td>
                                <td>{formatProperty(blended.corrosionStability?.[29])}</td>
                            </tr>

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        TRACE METALS

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Metal</th>
                                <th>Crude 1</th>
                                <th>Crude 2</th>
                                <th>Final Blend</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>Nickel (Ni)</td>
                                <td>{formatProperty(crude1?.traceMetals?.[31])}</td>
                                <td>{formatProperty(crude2?.traceMetals?.[31])}</td>
                                <td>{formatProperty(blended.traceMetals?.[31])}</td>
                            </tr>

                            <tr>
                                <td>Vanadium (V)</td>
                                <td>{formatProperty(crude1?.traceMetals?.[32])}</td>
                                <td>{formatProperty(crude2?.traceMetals?.[32])}</td>
                                <td>{formatProperty(blended.traceMetals?.[32])}</td>
                            </tr>

                            <tr>
                                <td>Iron (Fe)</td>
                                <td>{formatProperty(crude1?.traceMetals?.[33])}</td>
                                <td>{formatProperty(crude2?.traceMetals?.[33])}</td>
                                <td>{formatProperty(blended.traceMetals?.[33])}</td>
                            </tr>

                            <tr>
                                <td>Sodium (Na)</td>
                                <td>{formatProperty(crude1?.traceMetals?.[34])}</td>
                                <td>{formatProperty(crude2?.traceMetals?.[34])}</td>
                                <td>{formatProperty(blended.traceMetals?.[34])}</td>
                            </tr>

                            <tr>
                                <td>Calcium (Ca)</td>
                                <td>{formatProperty(crude1?.traceMetals?.[35])}</td>
                                <td>{formatProperty(crude2?.traceMetals?.[35])}</td>
                                <td>{formatProperty(blended.traceMetals?.[35])}</td>
                            </tr>

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        SARA ANALYSIS

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Component</th>
                                <th>Crude 1</th>
                                <th>Crude 2</th>
                                <th>Final Blend</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>Saturates</td>
                                <td>{formatProperty(crude1?.saraAnalysis?.[45])}</td>
                                <td>{formatProperty(crude2?.saraAnalysis?.[45])}</td>
                                <td>{formatProperty(blended.saraAnalysis?.[45])}</td>
                            </tr>

                            <tr>
                                <td>Aromatics</td>
                                <td>{formatProperty(crude1?.saraAnalysis?.[46])}</td>
                                <td>{formatProperty(crude2?.saraAnalysis?.[46])}</td>
                                <td>{formatProperty(blended.saraAnalysis?.[46])}</td>
                            </tr>

                            <tr>
                                <td>Resins</td>
                                <td>{formatProperty(crude1?.saraAnalysis?.[47])}</td>
                                <td>{formatProperty(crude2?.saraAnalysis?.[47])}</td>
                                <td>{formatProperty(blended.saraAnalysis?.[47])}</td>
                            </tr>

                            <tr>
                                <td>Asphaltenes (nC7)</td>
                                <td>{formatProperty(crude1?.saraAnalysis?.[48])}</td>
                                <td>{formatProperty(crude2?.saraAnalysis?.[48])}</td>
                                <td>{formatProperty(blended.saraAnalysis?.[48])}</td>
                            </tr>

                            <tr>
                                <td>Wax Content</td>
                                <td>{formatProperty(crude1?.saraAnalysis?.[50])}</td>
                                <td>{formatProperty(crude2?.saraAnalysis?.[50])}</td>
                                <td>{formatProperty(blended.saraAnalysis?.[50])}</td>
                            </tr>

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        LABORATORY INTERPRETATION

                    </h3>

                    <div className="remarks-box">

                        The corrosion indices, metallic contaminants and SARA
                        composition shown above were calculated from the blended
                        crude generated by the NK Tech Blend Engine.

                        <br /><br />

                        These parameters are used for evaluating refinery
                        fouling tendency, catalyst poisoning potential,
                        corrosion severity, storage stability and overall
                        refinery process compatibility.

                    </div>



                    <div className="receipt-page-footer">

                        Generated electronically by

                        <strong>

                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                        </strong>

                        <br />

                        Page 4 of 5

                    </div>

                </div>


                {/*=====================================================
PAGE 5
=====================================================*/}

                <div
                    ref={page5Ref}
                    className="receipt-page"
                >

                    <div className="customer-stamp">

                        FINAL CERTIFICATION

                    </div>

                    <div className="receipt-company">

                        <div className="receipt-logo">

                            NK

                        </div>

                        <div className="receipt-company-details">

                            <h2>

                                BLEND CERTIFICATE OF ANALYSIS

                            </h2>

                            <p>

                                Final Laboratory Certification

                            </p>

                        </div>

                    </div>

                    <hr />



                    <h3 className="section-title">

                        TBP DISTILLATION SUMMARY

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Recovery</th>
                                <th>Temperature</th>

                            </tr>

                        </thead>

                        <tbody>

                            {Object.entries(blended?.tbpDistillation || {}).map(([key, item]) => (
                                <tr key={key}>

                                    <td>{item.name}</td>

                                    <td>{formatYield(item)}</td>

                                </tr>
                            ))}

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        EXPECTED PRODUCT YIELDS

                    </h3>

                    <table className="receipt-table">

                        <thead>

                            <tr>

                                <th>Product</th>

                                <th>Weight %</th>

                                <th>Volume %</th>

                            </tr>

                        </thead>

                        <tbody>

                            {Object.entries(blended?.cutYields || {}).map(([name, item]) => (

                                <tr key={name}>

                                    <td>{name}</td>

                                    <td>{formatYield(item?.wt)}</td>

                                    <td>{formatYield(item?.vol)}</td>

                                </tr>

                            ))}

                        </tbody>

                    </table>



                    <h3 className="section-title">

                        LABORATORY CERTIFICATION

                    </h3>

                    <div className="remarks-box">

                        This blended crude assay has been automatically generated
                        using the NK Tech Industrial DCS Blend Engine.

                        <br /><br />

                        Laboratory values shown are calculated from the actual
                        blend ratio, feed crude properties and refinery blending
                        algorithms operating in real time.

                        <br /><br />

                        This report is intended for refinery planning,
                        digital twin simulation,
                        operator training,
                        process optimization,
                        laboratory familiarization and educational purposes.

                    </div>



                    <div className="receipt-security">

                        <div>

                            <strong>

                                DIGITAL VERIFICATION

                            </strong>

                            <div className="qr-placeholder">

                                <QRCode

                                    value={`Blend Report ${Date.now()}`}

                                    size={120}

                                />

                            </div>

                        </div>



                        <div className="receipt-disclaimer">

                            Generated automatically by

                            <br /><br />

                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                            <br /><br />

                            Unauthorized modification invalidates this report.

                        </div>

                    </div>



                    <div className="receipt-signatures">

                        <div className="signature-box">

                            _______________________

                            <br /><br />

                            Laboratory Analyst

                        </div>

                        <div className="signature-box">

                            _______________________

                            <br /><br />

                            Shift Supervisor

                        </div>

                        <div className="signature-box">

                            _______________________

                            <br /><br />

                            Operations Manager

                        </div>

                    </div>



                    <div className="receipt-page-footer">

                        BLEND LABORATORY REPORT

                        <br />

                        Generated electronically by

                        <strong>

                            NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                        </strong>

                        <br />

                        Page 5 of 5

                    </div>

                </div>


            </div>


        </div>



            {/*=====================================================
WINDOW FOOTER (NOT INCLUDED IN PDF)
=====================================================*/}

    <div className="receipt-footer no-print">

        <button
            className="receipt-btn print"
            onClick={handlePrint}
        >
            🖨 PRINT
        </button>

        <button
            className="receipt-btn pdf"
            onClick={handlePDF}
        >
            📄 DOWNLOAD PDF
        </button>

        <button
            className="receipt-btn close"
            onClick={onClose}
        >
            ✖ CLOSE
        </button>

    </div>


        </div >

        

    );


}


export default BlendLaboratory;